import styled from 'styled-components';
import { rem } from 'polished';

interface IStyledArticle {
  theme: any;
  maskImgBg: string;
  maskImgLeft: string;
  maskImgRight: string;
}

export const StyledArticle = styled.div<IStyledArticle>`
  .body {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
  }
  .main {
    flex: 0 1 auto;
  }
  && .heading .content {
    padding-top: ${rem(60)};
  }
  .spacer {
    flex: 1 0 24px;
  }
  .aside {
    flex: 1 0 350px;
    max-width: 350px;
  }
  .cta {
    margin-bottom: ${rem(`24px`)};
  }
  && .layout-wide__top .center-shape {
    background: red;
  }

  .article-meta {
    width: 100%;
    flex-direction: column;
    z-index: 999;
    margin-bottom: ${rem(`16px`)};
    padding: 0 ${rem(`16px`)} 0;
    .meta {
      position: relative;
      flex: 1 0 auto;
      align-items: flex-start;
    }
    .meta__text {
      padding-bottom: 0;
    }
    .tags {
      position: initial;
      flex-direction: column;
      justify-content: flex-start;
    }
    .tag:first-child {
      margin-left: 0;
    }
    .tag {
      margin-bottom: ${rem(`4px`)};
    }
    ${({ theme }) => theme.breakpoints.phablet`
      width: 100%;
      flex-direction: row;
      height: ${rem(`120px`)};
      z-index: 999;
      margin-bottom: ${rem(`16px`)};
      .meta {
        position: initial;
        flex: 1 0 auto;
        height: 100%;
        align-items: flex-end;
      }
      .meta__text {
        padding-bottom: ${rem(`24px`)};
      }
      .tags {
        right: 16px;
        position: absolute;
        flex-direction: row;
        justify-content: flex-end;
      }
      .tag:first-child {
        margin-left: ${rem(`50px`)};
      }
      .tag {
        margin-bottom: 0;
      }
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      flex-direction: row;
      height: ${rem(`120px`)};
      position: absolute;
      bottom: calc(100% + ${rem(`-48px`)});
      margin: 0;
      padding: 0;
      .author {
        position: absolute;
        top: ${rem(`-42px`)};
      }
      .meta {
        flex: 1 0 auto;
        position: relative;
        height: initial;
      }
      .tags {
        right: 0;
      }
    `}
  }

  .layout-wide__top {
    background-size: cover;
    mask-size: 1920px 700px, 0% 0px, 0% 0px;
    mask-position: center top, left top, right top;
    mask-repeat: no-repeat, no-repeat, no-repeat;
    mask-image: url(${({ maskImgBg }) => maskImgBg}),
      url(${({ maskImgLeft }) => maskImgLeft}),
      url(${({ maskImgRight }) => maskImgRight});
    @media (min-width: 1920px) {
      mask-size: 95% 700px, 2.5% 700px, 2.5% 617px;
    }
    @media (min-width: 2020px) {
      mask-size: 90% 700px, 5% 700px, 5% 617px;
    }
    @media (min-width: 2220px) {
      mask-size: 85%  700px, 7.5% 700px, 7.5% 617px;
    }
    @media (min-width: 2420px) {
      mask-size: 80% 700px, 10% 700px, 10% 617px;
    }
    @media (min-width: 2620px) {
      mask-size: 75% 700px, 12.5% 700px, 12.5% 617px;
    }
    @media (min-width: 2820px) {
      mask-size: 70% 700px, 15% 700px, 15% 617px;
    }
    @media (min-width: 3020px) {
      mask-size: 65% 700px, 17.5% 700px, 17.5% 617px;
    }
    @media (min-width: 3220px) {
      mask-size: 60% 700px, 20% 700px, 20% 617px;
    }
    @media (min-width: 3420px) {
      mask-size: 55% 700px, 22.5% 700px, 22.5% 617px;
    }
    @media (min-width: 3620px) {
      mask-size: 50% 700px, 25% 700px, 25% 617px;
    }
  }

  .top-container {
    min-height: ${rem(`724px`)};
  }

  .top-container .heading {
    grid-template-columns: 1fr;
  }

  .top-container .heading .content > div {
    max-width: 85%;
  }

  .main-title {
    display: inline;
    background-color ${({ theme }) => theme.colors.blue_1_65};
    color: ${({ theme }) => theme.colors.white_1_75};
    line-height: 1.75;
    text-wrap-style: balance;
    padding: 0 ${rem(`8px`)};
    box-decoration-break: clone;
    border-radius: ${rem(`16px`)};
    font-size:  ${rem(`36px`)};
    ${({ theme }) => theme.breakpoints.phablet`
      padding: 0 ${rem(`16px`)};
      font-size:  ${rem(`56px`)};
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      padding: 0 ${rem(`36px`)};
      font-size:  ${rem(`64px`)};
    `}
  }

  .layout__main {
    flex-direction: column;
    width: 100%;
  }

  .main-content {
    padding: 0;
  }

  .article-layout-inner {
    display: flex;
    flex-direction: row;
    ${({ theme }) => theme.breakpoints.phablet`
      padding: 0 ${rem(`16px`)};
    `}
    ${({ theme }) => theme.breakpoints.tablet`
      padding: 0;
    `}
  }

  .mobile-releated-articels .relatedArticles__content {
    ${({ theme }) => theme.breakpoints.tablet`
      grid-template-columns: repeat(2, 1fr);
    `}
  }

  deckgo-highlight-code, deckgo-highlight-code-edit {
    --deckgo-highlight-code-scroll: hidden;
    --deckgo-highlight-code-carbon-header-button-red-background: ${({
      theme,
    }) => theme.colors.blue_3_45};
    --deckgo-highlight-code-carbon-header-button-yellow-background: ${({
      theme,
    }) => theme.colors.blue_3_45};
    --deckgo-highlight-code-carbon-header-button-green-background: ${({
      theme,
    }) => theme.colors.blue_3_45};
    --deckgo-highlight-code-line-height: 1.325;
    --deckgo-highlight-code-carbon-background: ${({ theme }) =>
      theme.colors.blue_1};
    --deckgo-highlight-code-container-width: max-content;
    --deckgo-highlight-code-font-size: 12px;
    ${({ theme }) => theme.breakpoints.desktop`
      --deckgo-highlight-code-container-width: unset;
    `}
  }

  .hero-container {
    margin-top: ${rem(`12px`)};
    margin-bottom: 0;
    ${({ theme }) => theme.breakpoints.desktop`
      margin-bottom: ${rem(`48px`)};
    `}
  }

  .back-button {
    margin-bottom: ${rem(`24px`)};
    color: ${({ theme }) => theme.colors.white_1_45};
    padding: ${rem(`8px`)} ${rem(`12px`)};
    background-color: ${({ theme }) => theme.colors.blue_1_65};
    border-radius: ${rem(`12px`)};
    &:hover {
      color: ${({ theme }) => theme.colors.pink_1};
    }
    svg path {
      fill: ${({ theme }) => theme.colors.pink_1};
    }
  }

  .back-content {
    margin-left: ${rem(`4px`)};
  }

  .mobile-newsletter {
    align-items: center;
    .newsletter__form {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;
